module.exports = __webpack_public_path__ + "img/blockchain-network.cbc2fa66.png";